module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-4-image-fd96cbb8139bb1597b0a442238ef1f0a.png";